const env = import.meta.env.VITE_APP_ENV
// console.log(env, 'env')
// 本系统接口地址
const switchSystemLinkApi = ((value) => {
	let str = ''
	switch (value) {
		case 'production':
			str = 'https://api.53ofc.cn/api/'
			break;
		case 'demo':
			str = 'https://demo.api.53ofc.cn/api/'
			break;
		case 'test':
			str = 'http://dev.api.service.53tech.cn/api/'
			break;
		case 'testD':
			str = 'http://192.168.0.105:9512/api/'
			break;
		case 'development':
			str = 'http://192.168.0.239:9512/api/' // 192.168.0.239:9512
			break;
	}
	return str
})

// 统一登录接口地址
const switchSsoLinkApi = ((value) => {
	let str = ''

	if (value === 'production' || value === 'demo') {
		str = 'https://api.sso.53tech.cn/api/'
	} else {
		// test testD development
		str = 'http://dev.api.sso.53tech.cn/api/'
	}

	return str

	// switch (value) {
	// 	case 'production':
	// 		str = 'https://api.sso.53tech.cn/api/'
	// 		break;
	// 	case 'test':
	// 		str = 'http://dev.api.sso.53tech.cn/api/'
	// 		break;
	// 	case '105':
	// 		str = 'http://dev.api.sso.53tech.cn/api/'
	// 		break;
	// 	case 'development':
	// 		str = 'http://dev.api.sso.53tech.cn/api/'
	// 		break;
	// }
	// return str
})

// 本系统地址
const switchSystemLink = ((value) => {
	let str = ''
	switch (value) {
		case 'production':
			str = 'https://www.53ofc.cn'
			break;
		case 'demo':
			str = 'https://demo.53ofc.cn'
			break;
		case 'test':
			str = 'http://dev.service.53tech.cn'
			break;
		case 'testD':
			str = 'http://192.168.0.105:8084'
			break;
		case 'development':
			str = 'http://192.168.0.241:8084'
			break;
	}
	return str
})

// 统一登录地址
const switchSsoLink = ((value) => {
	let str = ''

	if (value === 'production' || value === 'demo') {
		str = 'https://sso.53tech.cn'
	} else {
		// test testD development
		str = 'http://dev.sso.53tech.cn'
	}

	return str

	// switch (value) {
	// 	case 'production':
	// 		str = 'https://sso.53tech.cn'
	// 		break;
	// 	case 'test':
	// 		str = 'http://dev.sso.53tech.cn'
	// 		break;
	// 	case 'development':
	// 		str = 'http://dev.sso.53tech.cn'
	// 		break;
	// }
	// return str
})

// 配置官网跳转地址（充值/预览）
const switchOfficialWebsiteLink = ((value) => {
	let str = ''
	const strS = '' // '/#'

	switch (value) {
		case 'production':
			str = 'https://www.53tech.cn' + strS
			break;
		case 'demo':
			str = 'https://www.53tech.cn' + strS
			break;
		case 'test':
			str = 'http://dev.www.53tech.cn' + strS
			break;
		case 'testD':
			str = 'http://192.168.0.105:8081' + strS
			break;
		case 'development':
			str = 'http://192.168.0.241:8081' + strS // 105 241
			break;
	}
	return str
})
// console.log(typeof env, 'env', switchSystemLinkApi(env))

export default {
	/**
	 * 是否固定头部
	 */
	fixedHeader: false,

	/**
	 * @type {string | array} 'production' | ['production', 'development']
	 * @description Need show err logs component.
	 * The default is only used in the production env
	 * If you want to also use it in dev, you can pass ['production', 'development']
	 */
	errorLog: 'production',
	systemLinkApi: switchSystemLinkApi(env), // 本系统接口地址
	ssoLinkApi: switchSsoLinkApi(env), // 统一登录接口地址
	systemLink: switchSystemLink(env), // 本系统地址
	ssoLink: switchSsoLink(env), // 统一登录地址
	hrefPage: 'service', // 当前系统类型 运维中心
	serviceLink: 'serviceLink', // 配置正式地址
	serviceDevLink: 'serviceDevLink', // 配置测试地址
	officialWebsiteJumpLink: switchOfficialWebsiteLink(env), // 官网预览跳转地址
	officialWebsiteLink: switchOfficialWebsiteLink(env) + '/shoppingMall', // 配置官网充值跳转地址
}